import React, {Component} from "react"

import authentication from "@irati/auth"
import {hangPromise} from "@irati/utils/promise"
import {PerksMetrics} from "@irati/types"
import Loading from "@irati/ui/src/Loading"
import tracking from "@irati-tracking/admin"
import reportingService from "@irati/admin/services/reporting/reporting"
import reportingErrorHandler from "@irati/admin/services/reporting/errors/reportingErrorHandler"
import {H2} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"

import PerksActivity from "./PerksActivity"
import ShareLink from "../../../components/ShareLink"

interface PerksAndPerksGoMetrics {
  perksMetrics: PerksMetrics
}

interface State {
  perksAndPerksGoMetrics: PerksAndPerksGoMetrics | any
  load: Promise<void>
}

class Interests extends Component<{}, State> {
  state: State = {
    perksAndPerksGoMetrics: {},
    load: hangPromise()
  }

  componentDidMount = () => {
    this.setState({
      load: this.getPerksActivity()
    })
    tracking.analyticsContent()
  }

  getPerksActivity = () => {
    const businessId = authentication.business().uuid
    return reportingService
      .getPerksMetrics(businessId)
      .then(({tenant}) => {
        this.setState({perksAndPerksGoMetrics: tenant})
      })
      .catch(reportingErrorHandler)
  }

  render() {
    const {load, perksAndPerksGoMetrics} = this.state

    return (
      <>
        <Flex justifyContent="space-between" marginBottom={4} marginTop={5}>
          <H2>
            <FormattedMessage id="admin.analytics.content.title" />
          </H2>
          <ShareLink report="perksActivityChart" />
        </Flex>
        <Loading load={load}>
          <PerksActivity perksAndPerksGoMetrics={perksAndPerksGoMetrics} />
        </Loading>
      </>
    )
  }
}

export default Interests
